import { ApiCurrency } from "@/types/currency.types.ts";
import { ApiJobLevel } from "@/types/job-level.types.ts";
import { ApiJobRole } from "@/types/job-role.types.ts";
import { ApiOrganizationListItem } from "@/types/organization-list.types.ts";
import { ApiFilterBase } from "@skailer-com/uikit/core";

export interface ApiJobProfileShort {
  id: number;
  system_title: string;
  display_title: string;
  description: string | null;
  role: ApiJobRole;
  level: ApiJobLevel;
  is_archived: boolean;
}

export interface ApiJobProfile extends ApiJobProfileShort {
  track: ApiOrganizationListItem | null;
  grade: ApiOrganizationListItem | null;
  salary: ApiJobProfileSalary | null;
  standard_weekly_hours: number | null;
}

export interface ApiJobProfileSearchPayload extends ApiFilterBase {
  text: string;
  include_archived: boolean;
}

export interface ApiJobProfileSalary {
  salary_min: number | null;
  salary_max: number | null;
  currency: ApiCurrency | null;
}

export const getJobProfileTitle = (profile: ApiJobProfileShort) => profile.display_title;

export interface ApiJobProfileSavePayload {
  job_role_id: number;
  job_level_id: number;
  title: string | null;
  description: string | null;
  currency_code: string | null;
  salary_min: number | null;
  salary_max: number | null;
  standard_weekly_hours: number | null;
}

export interface ApiJobProfileMatrixPayload {
  job_role_id: number;
  level_ids: number[];
}

export interface ApiJobProfileMovePayload {
  job_role_id?: number;
  job_level_id?: number;
}
